import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useQuery } from '@tanstack/react-query';
import { OrderBy } from '../use-sort-and-pagination/use-sort-and-pagination.types';
import { MaintenancesFilters } from '@/services/maintenances-service/maintenances-service.types';
import { getMaintenances } from '@/services/maintenances-service/maintenances-service';

interface MaintenancesFiltersProps {
  filtersParams: MaintenancesFilters;
  paginationParams: {
    sort_by?: string;
    order_by: OrderBy;
    page: number;
    items_per_page: number;
  };
}

export const useMaintenances = ({ filtersParams, paginationParams }: MaintenancesFiltersProps) => {
  const {
    data: maintenancesData,
    error,
    isPending,
    refetch,
  } = useQuery({
    queryKey: ReactQueryKeys.MAINTENANCES({ ...filtersParams, ...paginationParams }),
    queryFn: () => getMaintenances({ ...filtersParams, ...paginationParams }),
  });

  return { maintenancesData, error, isPending, refetch };
};
